import type { MarkdownToJSX } from "markdown-to-jsx";
import type { FC } from "react";
import { ExternalAnchorLink } from "../ExternalAnchorLink.tsx";
import styles from "./MarkdownComponents.module.css";
import { H1, H2, H3, H4, H5, H6, P } from "./MarkdownComponents.tsx";

const BLOCKED_ELEMENTS = [
  "applet",
  "area",
  "audio",
  "base",
  "bgsound",
  "big",
  "blink",
  "body",
  "button",
  "datalist",
  "dialog",
  "embed",
  "fieldset",
  "footer",
  "form",
  "frame",
  "frameset",
  "head",
  "header",
  "html",
  "iframe",
  "input",
  "label",
  "legend",
  "link",
  "main",
  "map",
  "marquee",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "object",
  "optgroup",
  "option",
  "output",
  "portal",
  "progress",
  "select",
  "slot",
  "style",
  "template",
  "textarea",
  "title",
  "track",
  "video",
];

const getEmptyElements = () => {
  const elements: Record<string, { component: FC }> = {};

  BLOCKED_ELEMENTS.forEach((element) => {
    elements[element] = { component: () => null };
  });

  return elements;
};

export const DEFAULT_MARKDOWN_OPTIONS: MarkdownToJSX.Options = {
  wrapper: (props) => <div className={styles.markdown} {...props} />,
  forceBlock: true,
  forceWrapper: true,
  overrides: {
    ...getEmptyElements(),
    a: {
      component: ExternalAnchorLink,
    },
    h1: {
      component: H1,
    },
    h2: {
      component: H2,
    },
    h3: {
      component: H3,
    },
    h4: {
      component: H4,
    },
    h5: {
      component: H5,
    },
    h6: {
      component: H6,
    },
    p: {
      component: P,
    },
  },
};
